import { Service } from '@/request/http.js'

// 根据城市/酒店ID，获取国家和城市信息
export function getCityInfo (data) {
  return Service({
    url: '/api/getCityInfo',
    method: 'post',
    params: data
  })
}

export function getRegisterInfo (data) {
  return Service({
    url: '/api/getRegisterInfo',
    method: 'post',
    params: data
  })
}

export function getCityByCountry (data) {
  return Service({
    url: '/api/getRegisterInfo',
    method: 'post',
    params: data
  })
}

export function register (data) {
  return Service({
    url: '/api/register',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/city.js